import { NEW_HOST_URL } from "../../config/envConfig";
import { fetch } from "../../utils";

export const getWorkspacesCount = async () => {
  return fetch(`${NEW_HOST_URL}/workspaces/count`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const createWorkspaceUser = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace/${data?.workspaceId}/user`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      photo: data?.photo,
      email: data?.email,
      password: data?.password,
      role: data?.role,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteWorkspace = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace/${data?.workspaceId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkspaces = async (data) => {
  //fromDate=${data?.fromDate}&toDate=${data?.toDate}
  return fetch(
    `${NEW_HOST_URL}/workspaces?page=${data?.page}&pageSize=${data?.pageSize}&searchQuery=${data?.search}&organizationId=${data?.organizationId || ""}&fromDate=${data?.fromDate || ""}&toDate=${data?.toDate || ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const editWorkspace = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace/${data?.workspaceId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      name: data?.name,
      logo: data?.logo,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkspaceAssignableUsers = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace/${data?.workspaceId}/users/assignable`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const assignWorkspaceUser = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace/${data?.workspaceId}/user/${data?.userId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      role: data?.role,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkspaceUsers = async (data) => {
  //fromDate=${data?.fromDate}&toDate=${data?.toDate}
  let roles = data?.roles ? JSON.stringify(data.roles) : "";
  let role = data?.role && data?.role !== "superadmin" ? `&role=${data?.role}` : "";
  return fetch(
    `${NEW_HOST_URL}/workspace/${data?.workspaceId}/users?page=${data?.page}&searchQuery=${data?.search}&pageSize=${data?.pageSize}&fromDate=${data?.fromDate || ""}&toDate=${data?.fromDate || ""}&roles=${roles}${role}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("authToken"),
      },
    },
  )
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkspaceDetails = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace/${data?.entityId}?getConfig=${data?.getConfig || false}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const getWorkspacesByCategory = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspaces/${data?.entityId}?category=${data?.category || null}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
